export const SPOTIFY_CONFIG = {
    CLIENT_ID: "56abd128f05147af8d3fd6bd00fa7b4c",
    CLIENT_SECRET: "dd0060f93b764722b7fd67abc7f1edf4",
    PLAYLIST_ID: "7crl8ZwgBsOi5VVPHZLjBx",
};